import React, { useContext } from "react"
import { useHistory, useLocation } from "react-router-dom"
import Context from "../utils/Context"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons'
import LogoFI from "../assets/images/logo.png"
import LogoCliente from "../assets/images/logo-cliente.gif"

function Navigation() {

  const context = useContext(Context)
  let history = useHistory()
  let location = useLocation()

  // get current url location
  let currentLocation = location.pathname.split("/")

  // log out function
  const signout = () => {
    context.actions.setApiToken(null)
    context.actions.setUser(null)
    if (window.rosConnected) window.ros.close()
    window.rosConnected = false
    context.actions.setSelectedRobot(false)
    context.actions.setSelectedTypeRobot(null)
    context.actions.setIsRobotConnected(false)
    history.push("/login")
  }

  return (
    <>
      <div className="columns">
        <div className="column">
          {context.settings.fmsConnection &&
            <div className="bd-notification is-info has-text-right">
              <button className="button is-outlined is-link mr-2 mb-5" onClick={() => signout()}>
                <FontAwesomeIcon icon={faSignInAlt} className="is-small mr-1" />
                Logout
              </button>
            </div>
          }

          <div className="columns is-mobile">
            <div className="column">
              <p className="bd-notification is-info">

                <img
                  style={{ height: '90px', maxWidth: '240px', objectFit: "contain" }}
                  alt="logo-fi"
                  src={LogoFI}
                  className="mb-6"
                ></img>

              </p>
            </div>

            <div className="column">
              <p className="bd-notification is-info is-pulled-right">
               {/*} <img
                  style={{ height: '90px', maxWidth: '240px', objectFit: "contain" }}
                  alt="logo-cliente"
                  src={""}
                  disable
                ></img>
                */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>

  )
}

export default Navigation
